import styled from 'styled-components';

export const Wrapper = styled.section`
  padding: 32px 16px;
  background-color: #f8fafc;
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
  margin-bottom: 6px;
`;

export const SectionSubtitle = styled.div`
  font-size: 14px;
  color: #64748b;
  text-align: center;
  margin-bottom: 20px;
`;

export const ToggleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  font-size: 14px;
  font-weight: 600;
  color: #475569;
`;

export const DiscountBadge = styled.span`
  background-color: #f3e8ff;
  color: #8b5cf6;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 12px;
  margin-left: 4px;
`;

export const TariffsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 28px;
`;

export const TariffCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  border: ${props => props.$popular ? '2px solid #8b5cf6' : '1px solid #f1f5f9'};
  box-shadow: ${props => props.$popular ? '0 10px 25px rgba(139, 92, 246, 0.1)' : '0 2px 8px rgba(0,0,0,0.02)'};
  position: relative;
`;

export const PopularBadge = styled.div`
  position: absolute;
  top: -12px;
  right: 20px;
  background: #8b5cf6;
  color: white;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 10px;
  text-transform: uppercase;
`;

export const TariffName = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 4px 0;
`;

export const TariffPosts = styled.div`
  font-size: 13px;
  color: #64748b;
  margin: 0 0 16px 0;
  font-weight: 500;
`;

export const PriceBox = styled.div`
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-bottom: 16px;
`;

export const PriceAmount = styled.span`
  font-size: 28px;
  font-weight: 800;
  color: #0f172a;
`;

export const PricePeriod = styled.span`
  font-size: 13px;
  color: #64748b;
`;

export const FeaturesList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 20px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FeatureItem = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #334155;
`;

export const PaymentInfoBox = styled.div`
  background: #ffffff;
  border-radius: 14px;
  padding: 16px;
  border: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PaymentTitle = styled.h4`
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
`;

export const PaymentMethodsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  color: #475569;
`;

export const CancelNotice = styled.div`
  font-size: 12px;
  color: #059669;
  font-weight: 600;
  margin: 4px 0 0 0;
`;
